import gql from "graphql-tag";

export default gql`
  query FinancialHighlights($issuerId: ObjectID!, $financialHighlightsId: ObjectID) {
    financialHighlights(issuerId: $issuerId, financialHighlightsId: $financialHighlightsId) {
      financialHighlights {
        _id
        fiscalPeriodDate
        fiscalPeriodQuarter
        highlights
        oneLiner
      }
      reportSource {
        dateOfReference
        deliveryDate
        type
        pdfURL
      }
      availableHighlights {
        _id
        description
      }
    }
  }
`;
